import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-hd _fw-eb _tc--dark _grow-1" }
const _hoisted_2 = { class: "_mb-1 gfu-hd--h2" }
const _hoisted_3 = {
  class: "_fw-n",
  "data-qa": "quantity"
}
const _hoisted_4 = { "data-qa": "product-name" }
const _hoisted_5 = { class: "gfu-price gfu-price--text-base" }
const _hoisted_6 = { class: "gfu-price gfu-price--old gfu-hd--h4 _fw-n _ml-1" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_thumb = _resolveComponent("base-thumb")
  const _component_display_currency_price = _resolveComponent("display-currency-price")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['gfu-product-details-info', {'gfu-product-details-info--single-item': $props.isSingleItem}]),
    "data-qa": "product-info"
  }, [
    _createVNode(_component_base_thumb, {
      size: "medium",
      "image-url": $props.productData.imageUrl,
      alt: $options.productName
    }, null, 8 /* PROPS */, ["image-url", "alt"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString($props.quantity) + "x", 1 /* TEXT */),
        _cache[0] || (_cache[0] = _createTextVNode()),
        _createElementVNode("span", _hoisted_4, _toDisplayString($options.productName), 1 /* TEXT */)
      ]),
      _createVNode(_component_display_currency_price, {
        "effective-price": $options.effectivePrice,
        price: $options.price,
        "is-discounted": $props.isDiscounted,
        class: "gfu-hd--h2 _flex _ai-c",
        "data-qa": "price"
      }, {
        "effective-price": _withCtx(({ effectivePrice }) => [
          _createElementVNode("span", _hoisted_5, _toDisplayString(effectivePrice), 1 /* TEXT */)
        ]),
        price: _withCtx(({ price }) => [
          _createElementVNode("span", _hoisted_6, _toDisplayString(price), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["effective-price", "price", "is-discounted"]),
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 2 /* CLASS */))
}